<!-- TODO (GB-7600): add shared translations -->
<span matSnackBarLabel>{{ data.message }}</span>
<span matSnackBarActions>
  <button class="action-button" mat-button matSnackBarAction (click)="action(true)">OK</button>
</span>
